import { CRYPTO_PROVIDER } from '../../types/enums';
import type { MarketplaceConfig } from '../../queries/marketplace';

type CryptoMarketplaceConfig = Pick<
  MarketplaceConfig['marketplaceConfig'],
  'cryptoProvider' | 'moralis' | 'zeroXProcessing'
>;

const CRYPTO_CASHIER_RESOLVERS = {
  [CRYPTO_PROVIDER.MORALIS]: (config?: CryptoMarketplaceConfig) =>
    ({
      provider: CRYPTO_PROVIDER.MORALIS,
      requiresMethodBeforeForm: true,
      depositEnabled: config?.moralis?.depositEnabled !== false,
      withdrawalEnabled: config?.moralis?.withdrawalEnabled !== false,
    }) as const,
  [CRYPTO_PROVIDER.ZERO_X_PROCESSING]: (config?: CryptoMarketplaceConfig) =>
    ({
      provider: CRYPTO_PROVIDER.ZERO_X_PROCESSING,
      // Currency/network selection happens inside the form, after the shared picker stage.
      requiresMethodBeforeForm: false,
      depositEnabled: config?.zeroXProcessing?.enabled === true && config.zeroXProcessing.depositEnabled === true,
      withdrawalEnabled: config?.zeroXProcessing?.enabled === true && config.zeroXProcessing.withdrawalEnabled === true,
    }) as const,
};

export type CryptoCashierConfig = ReturnType<(typeof CRYPTO_CASHIER_RESOLVERS)[keyof typeof CRYPTO_CASHIER_RESOLVERS]>;

export const resolveCryptoCashierConfig = (config?: CryptoMarketplaceConfig): CryptoCashierConfig => {
  // Existing marketplaces without a provider selection continue to use Moralis.
  const provider = config?.cryptoProvider ?? CRYPTO_PROVIDER.MORALIS;

  return CRYPTO_CASHIER_RESOLVERS[provider](config);
};
